import { useCallback } from 'react'
import { reassignWorkflow } from '../application/reassign-workflow'
import { workItems$ } from '../store'
import { workItems as workItemsPort, notify } from '../wiring'
import { getWorkItemActor } from './use-work-item-actor'

type ReassignArgs = {
	id: string
	companyWorkflowId: string
	phaseId: string
	firstStepId: string
}

const useReassignWorkflow = () => {
	const reassign = useCallback(async (args: ReassignArgs) => {
		const item = workItems$.get().find(w => w.id === args.id)
		if (!item) return null
		const ctx = getWorkItemActor()
		const updated = await reassignWorkflow(workItemsPort, item, { ...args, actorId: ctx.actorId, actorName: ctx.actorName }, ctx, notify)
		if (updated) {
			// The item now lives in another workflow; drop it from the current board.
			workItems$.set(workItems$.get().filter(w => w.id !== updated.id))
		}
		return updated
	}, [])

	return { reassign }
}

export { useReassignWorkflow }
